export default __webpack_public_path__ + "static/media/nft-22.665bd214.png";